import React, { useState } from "react";
import { createGallery } from "./FetchApi";

const GalleryMenu = ({ onUploaded }) => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) return alert("Veuillez sélectionner un fichier image ou vidéo");
    setLoading(true);
    let res = await createGallery(file);
    setLoading(false);
    if (res && res.success) {
      setFile(null);
      if (onUploaded) onUploaded();
      alert("Media ajouté avec succès");
    } else if (res && res.error) {
      alert(res.error);
    }
  };

  return (
    <div className="bg-white p-4 rounded shadow">
      <h3 className="font-semibold mb-3">Ajouter un média</h3>
      <form onSubmit={handleSubmit} className="flex flex-col space-y-3">
        <input
          accept="image/*,video/*"
          onChange={(e) => setFile(e.target.files[0])}
          type="file"
        />
        <div>
          <button
            className="bg-blue-600 text-white px-4 py-2 rounded"
            type="submit"
            disabled={loading}
          >
            {loading ? "Chargement..." : "Uploader"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default GalleryMenu;
